module.exports = __webpack_public_path__ + "img/multi-step-quiz.9e372b8a.png";